/**
 *  Theme JS Bundle
 */

import './app.js';
import { newsCarousel } from './src/newsCarousel.js';
import { parallaxArea } from './src/parallaxArea.js';

document.addEventListener('DOMContentLoaded', function () {
  const version = '0.9.7';
  console.log('version ', version);

  // add `page-loaded` class to main container (for animation start/portrait block template)
  window.onload = function() {
    let container = document.querySelector('.ccm-page');
    if (container) container.classList.add('page-loaded');
  }

  // initiating news carousel
  newsCarousel();

  // initiating parallax area
  parallaxArea();
});
